import React, { useState, useEffect } from 'react';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';
import cn from 'classnames';
import TesterReviewItem from '@app/activity/testerClub/TesterReviewItem';
import { getActivityReviewPage } from 'mod/review/service';
import { IReviewPage } from 'mod/review/interface';
import { Button } from '@base/lib/Button'
import { IResultViewType } from '@pro/activity/testerClub/interface';
import { scrollToAnchor } from 'base/utils/scrollTo';
import delay from 'base/utils/delay';

type IProps = {
    results: IUseEarlyAccessResults;
    viewType?: IResultViewType;
}

const ResultsTesterReviews: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const { results, viewType } = props;
    const { resultsData } = results;

    const { activityGid = '' } = resultsData || {}
    const [reviewsData, setReviewsData] = useState<IReviewPage>()
    const [loading, setLoading] = useState<boolean>(true)

    const getTesterReviews = async (params: {
        page: number;
    }) => {
        try {
            setLoading(true);
            const res = await getActivityReviewPage({
                pageSize: 10,
                reviewType: 'early_access',
                activityIds: [activityGid],
                ...params
            });
            setReviewsData({
                ...res,
                list: [
                    ...(reviewsData?.list || []),
                    ...(res.list || [])
                ]
            })


            const _scrollBody = document.getElementById('js-results-content')
            if (viewType === 'review' && _scrollBody) {
                await delay(10)
                scrollToAnchor({
                    scrollWrap: _scrollBody,
                    selector: `#js-review-container`,
                })
            }

        } catch (err) {

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getTesterReviews({
            page: 1,
        }).then()
    }, [activityGid]);

    return !reviewsData?.list?.length ? null : (
        <div id={'js-review-container'} className={styles['reviews-wrap']}>
            <h3 className={styles.title}>
                {t('web_early_access_tester_reviews')}
            </h3>

            <div className={cn(
                styles.list,
            )}>
                {reviewsData?.list?.map((item, index) => {
                    return (
                        <TesterReviewItem
                            key={index}
                            review={item}
                            className={styles['item']}
                        />
                    )
                })}

            </div>

            {reviewsData.totalPage > reviewsData.page && (
                <div className={cn(styles['page-warp'], 'text-center')}>
                    <Button
                        loading={loading}
                        type={'link'}
                        onClick={() => {
                            getTesterReviews({
                                page: reviewsData.page + 1,
                            }).then()
                        }}
                    > More &gt; </Button>
                </div>
            )}

        </div>
    );
};

export default ResultsTesterReviews;